<template>
  <div class="player">
    <!-- 스크래치 캔버스 -->
    <!-- 일단 실습방 자체를 위해 하단 비활성화 -->
    <!-- <div class="prctice-header">Scratch Prctice Header</div> -->
    <!-- <div class="prctive-contents"> -->
    <!-- <Scrtc-Lib></Scrtc-Lib> -->
    <!-- <modal-learning-guide v-if="showGuide" @close="showGuide= false" :guideData="guideData"></modal-learning-guide> -->
    <!-- </div> -->
  </div>
</template>

<script>

/** Scratch Library를 해당 View에서만 독립적으로 Import **/
// import * as ScrtcLib from '../../public/scrtc/lib.min'
// import * as ScrtcGui from '../../public/scrtc/gui'

import { BASEURL, APIURL } from '../data/config';

export default {
  name: 'Scratch Player',
  mounted () {
    /*********** Scratch 라이브러리를 HTTP를 통해 직접 호출하여 Import 처리  ***************/
    // Region Start
    // Scratch Default Library
    const plugin1 = document.createElement("script");
    plugin1.setAttribute(
      "src",
      BASEURL + "/upload/lcm/lctre/blck/scratch/lib/scrtc/lib.min.js"
    );
    // plugin1.async = true;
    document.head.appendChild(plugin1);

    // Scratch GUI Library
    const plugin2 = document.createElement("script");
    plugin2.setAttribute(
      "src",
      BASEURL + "/upload/lcm/lctre/blck/scratch/lib/scrtc/player.js"
    );
    // plugin2.async = true;
    document.head.appendChild(plugin2);
    // Region End
  }
}
</script>

<style lang="scss">
.player {
  //       margin:0px;
  //       padding:0px;
  //       width:100%;
  //       height:100%;
  //       display:table;

  //       &-header {
  //         background-color:#fd3d1d;
  //         display:table-row;
  //         width:100%;
  //         height:50px;
  //         text-align: center;
  //       }

  //       &-contents{
  //         display:table-row;
  //         width:100%;
  //       }
}
</style>

